import { Transition } from '@headlessui/react'
import Translation from 'components/Translation'
import { MouseEvent, ReactElement } from 'react'

export type AlertErrorProps = {
    title: string
    class_name?: string
    icon?: ReactElement
    children?: ReactElement
    actions?: ReactElement<HTMLButtonElement>[]
    onClose(e: MouseEvent<HTMLButtonElement>): void
    onCloseAnimationFinish?(): void
}
export default function AlertError(p: AlertErrorProps) {
    return (
        <Transition
            show={p.title.length > 0}
            enter="transition-opacity duration-200"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-all duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            as="div"
            className="fixed top-0 w-full bg-black bg-opacity-30 backdrop-saturate-0 backdrop-blur-sm h-screen z-30 flex justify-center"
            afterLeave={p.onCloseAnimationFinish}
        >
            <Transition.Child
                enter="transition-all duration-600"
                enterFrom="-translate-y-8"
                enterTo="translate-y-0"
                leave="transition-all duration-300"
                leaveFrom="translate-y-0 opacity-30"
                leaveTo="-translate-y-64 opacity-0"
            >
                <div
                    className={`px-6 pb-8 pt-12 bg-white ${
                        p.class_name ? p.class_name : 'w-[30rem]'
                    } rounded-xl mx-auto text-center mt-20 shadow-2xl`}
                >
                    {p.icon || (
                        <i className="feather-alert-triangle bg-red-500 text-white rounded-full w-10 h-10 block mx-auto pt-1 text-lg" />
                    )}
                    <h3 className="text-2xl font-semibold text-primary mt-6 mb-4 leading-none whitespace-pre-line">
                        <Translation content_key={p.title} />
                    </h3>
                    {p.children || ''}
                    <div className="flex justify-center items-center mt-10 gap-4 px-10">
                        {p.actions || (
                            <button
                                className="w-48 h-12 text-lg bg-primary text-white rounded-lg px-6"
                                type="button"
                                onClick={p.onClose}
                            >
                                <Translation content_key="close" />
                            </button>
                        )}
                    </div>
                </div>
            </Transition.Child>
        </Transition>
    )
}
